import { ApplicationInsights } from '@microsoft/applicationinsights-web'

let appInsights

export const AnalyticsEventNames = Object.freeze({
  BUTTON_CLICKED: 'Button Clicked',
  CHECKBOX_CHECKED: 'Checkbox Checked',
  TAB_CLICKED: 'Tab Clicked',
  NAV_CLICKED: 'Navigation Clicked',
  LINK_CLICKED: 'Link Clicked',
  CARD_CLICKED: 'Card Clicked',
  USER_LOG_IN: 'User log in',
  TILE_CLICKED: 'Tile Clicked',
  DROPDOWN_SELECTED: 'Selection Updated',
  SLIDER_UPDATED: 'Slider Updated',
  ERROR_STATE: 'ErrorState',
})

/**
 * Create the App Insights Telemetry Service
 */
const createInsightsService = () => {
  /**
   * Initialize the Application Insights class
   * @param {string} instrumentationKey - Application Insights Instrumentation Key
   * @return {void}
   */
  const initialize = (instrumentationKey) => {
    if (!instrumentationKey) {
      throw new Error('Instrumentation key not provided')
    }

    appInsights = new ApplicationInsights({
      config: {
        instrumentationKey,
        disableFetchTracking: false,
        disableAjaxTracking: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        enableAutoRouteTracking: true,
      },
    })

    appInsights.loadAppInsights()
    appInsights.trackPageView({ name: 'App Session' })
  }

  return { appInsights, initialize }
}

export const ai = createInsightsService()
export const getAppInsights = () => appInsights

/**
 * Used to track analytics throughout the app. Generates a finalAnalyticsData
 * object. Each clickable component (CustomLink, Button, etc) is responsible
 * for calling this function and passing in the necessary analyticsData object
 * in their onClick callback.
 */
export const trackAnalytics = (eventName, data = {}, event = null) => {
  const appInsights = getAppInsights()

  const finalAnalyticsData = {
    name: data?.eventNameOverride || eventName,
    properties: {
      Properties: {
        ...{
          patientId: null,
          channel: 'FMH-Proxy',
          pageURL: window.location.href,
        },
        ...data,
        event: event || null,
      },
    },
  }

  if (typeof appInsights !== 'undefined') {
    try {
      appInsights.trackEvent({ ...finalAnalyticsData })
    } catch (e) {
      console.error(e)
    }
  }
}
